module.exports = __webpack_public_path__ + "img/cycle-3.f171a413.jpg";